import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';

/**
 * `/my-tasks` opens for Integrated Management, PAS, or both. It waits for both answers before
 * deciding, so a user never sees one layout and then another.
 */
export const resolveMyTasksAccess = (
  integratedManagement: AccessDecision,
  pas: AccessDecision,
): AccessDecision => {
  if (integratedManagement === 'loading' || pas === 'loading') return 'loading';
  if (integratedManagement === 'allow' || pas === 'allow') return 'allow';
  return 'deny';
};
